module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"eco_part":"dont {x} d\u0027éco-part"}}')
  delete Component.options._Ctor
}
